<template>
  <div class="content">
    <div class="content-navigation" id="content-navigation">
      <el-scrollbar>
        <ol>
          <li class="navigation" :class="nav.tag" v-for="nav in navigations">
            <img :src="nav.url" style="float: left;padding-top: 3px;">
            <a class="shell_item" href="javascript:void(0)" @click="jump(nav.index)" v-html="nav.name"></a>
          </li>
        </ol>
      </el-scrollbar>
    </div>
    <div class="content-content">
      <iframe :src="isrc1" v-if="index == 0" frameborder="false" width="1230px" height="700px"
              style="z-index: 100;margin-left: 0;float:left"></iframe>
      <iframe :src="isrc2" v-else-if="index == 1" frameborder="false" width="1230px" height="700px"
              style="z-index: 100;margin-left: 0;float:left"></iframe>
      <iframe :src="isrc3" v-else-if="index == 2" frameborder="false" width="1230px" height="700px"
              style="z-index: 100;margin-left: 0;float:left"></iframe>
      <iframe :src="isrc4" v-else-if="index == 3" frameborder="false" width="1230px" height="700px"
              style="z-index: 100;margin-left: 0;float:left"></iframe>
      <iframe :src="isrc5" v-else-if="index == 4" frameborder="false" width="1230px" height="700px"
              style="z-index: 100;margin-left: 0;float:left"></iframe>
      <iframe :src="isrc6" v-else-if="index == 5" frameborder="false" width="1230px" height="700px"
              style="z-index: 100;margin-left: 0;float:left"></iframe>
      <iframe :src="isrc7" v-else-if="index == 6" frameborder="false" width="1230px" height="700px"
              style="z-index: 100;margin-left: 0;float:left"></iframe>
      <iframe :src="isrc8" v-else-if="index == 7" frameborder="false" width="1230px" height="700px"
              style="z-index: 100;margin-left: 0;float:left"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "shellcharts",
  data() {
    return {
      index: 0,
      items: [],
      project_id: '',
      navigations: [
        {index: 0, url: require('../../assets/img/navi01.png'), tag: 'navi1', name: 'PTW'},
        {index: 1, url: require('../../assets/img/navi02.png'), tag: 'navi2', name: 'TBM'},
        {index: 2, url: require('../../assets/img/navi03.png'), tag: 'navi3', name: 'Checklist'},
        {index: 3, url: require('../../assets/img/navi04.png'), tag: 'navi4', name: 'WSH Inspection'},
        {index: 4, url: require('../../assets/img/navi05.png'), tag: 'navi5', name: 'RA'},
        {index: 5, url: require('../../assets/img/navi06.png'), tag: 'navi6', name: 'Training'},
        {index: 6, url: require('../../assets/img/navi07.png'), tag: 'navi7', name: 'Meeting'},
        {index: 7, url: require('../../assets/img/navi08.png'), tag: 'navi8', name: 'Incident'},
      ],
      isrc1: "",
      isrc2: "",
      isrc3: "",
      isrc4: "",
      isrc5: "",
      isrc6: "",
      isrc7: "",
      isrc8: "",
    }
  },
  mounted() {
    this.project_id = this.$route.query.proj_id
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.project_id = "3177"
    }
    var address = this.$store.getters.getServer241Address + "ctmgr/index.php?r=chart/send&program_id="
    this.isrc1 = address + this.project_id + "&app_id=PTW";
    this.isrc2 = address + this.project_id + "&app_id=TBM";
    this.isrc3 = address + this.project_id + "&app_id=CHECKLIST";
    this.isrc4 = address + this.project_id + "&app_id=WSH";
    this.isrc5 = address + this.project_id + "&app_id=RA";
    this.isrc6 = address + this.project_id + "&app_id=TRAIN";
    this.isrc7 = address + this.project_id + "&app_id=MEET";
    this.isrc8 = address + this.project_id + "&app_id=ACCIDENT";
    this.init()
  },
  methods: {
    init() {
      this.items = document.querySelectorAll('.shell_item')
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].dataset.order = i
      }
      this.items[this.index].classList.add('shell_active')
    },
    jump(clickIndex) {
      this.index = clickIndex
      let activeItem = document.querySelector('.shell_active')
      let activeIndex = activeItem.dataset.order
      let clickItem = this.items[clickIndex]
      if (activeIndex == clickIndex) {
        return
      }
      activeItem.classList.remove('shell_active')
      clickItem.classList.add('shell_active')
    },
  }

}
</script>

<style scoped>
.content {
  width: 100%;
  height: 1000px;
  /*min-height: 500px;*/
}

.navigation {
  font-size: 14px;
  color: #A5BDC0;
  margin-top: 12px;
}

.content-content {
  position: absolute;
  /*绝对定位*/
  top: 0px;
  margin-left: 14.5%;
  background: #272B43;
  width: 1440px;
  height: 732px;
  z-index: 50;
  overflow: hidden;
}

ol {
  list-style: none;
  margin-top: 0;
  margin-left: -15px;
  width: 180px;
  height: 800px;
}

a {
  color: black;
  font-size: 16px;
  text-decoration: none;
  margin-left: 2px;
}

.content-navigation {
  /*固定定位*/
  top: 14%;
  left: 12.5%;
  width: 200px;
  background: rgb(251, 251, 251);
  max-height: 800px;
  z-index: 2;
}

h4 {
  margin-top: 10px;
  margin-bottom: 10px;
}

p {
  margin: 0 0 10px;
}

.shell_item {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.shell_active {
  border-bottom: 1px solid #08a5df;
  color: #08a5df !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shellcharts/shellcharts.vue